import { MenuItem, Select } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { SearchTypes } from "../../hooks/useVenueSearch";

export interface IOverviewSelectProps {
    selected: SearchTypes;
    onSelected: (type: SearchTypes) => void;
}


export function OverviewSelect({ selected, onSelected }: IOverviewSelectProps) {
    const { t } = useTranslation();
    const MENU = [
        SearchTypes.VENUE_NAME,
        SearchTypes.VENUE_SERIAL_ID
    ]
    return <>
        <Select
            value={selected}
            onChange={(ev) => onSelected(ev.target.value as SearchTypes)}
            fullWidth
            renderValue={(value) => t('OverviewPage.OverviewSearch.label', { value: t(`OverviewPage.OverviewSearch.${value}`) })}
        >
            {MENU.map((searchType) => {
                return <MenuItem value={searchType}>
                    {t(`OverviewPage.OverviewSearch.${searchType}`)}
                </MenuItem>
            })}
        </Select>
    </>
}